/**
 * Utility functions for video handling
 */

// Generate a thumbnail path from a video URL
export const generateVideoThumbnail = (videoSrc: string): string => {
  // Extract filename from path
  const filename = videoSrc.split('/').pop()?.split('.')[0] || 'video';
  // Return path to thumbnail
  return `/thumbnails/${filename}.jpg`;
};

// Preload video metadata only with optimización y caché
export const preloadVideoMetadata = (src: string) => {
  if (!src) return;
  
  try {
    const getYouTubeId = (url: string): string => {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return (match && match[2].length === 11) ? match[2] : '';
    };
    
    const videoId = getYouTubeId(src);
    if (!videoId) return;
    
    // Just preload the thumbnail image instead of anything API-related
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`;
    link.as = 'image';
    document.head.appendChild(link);
  } catch (e) {
    // Silent fail
  }
};


// Map section IDs to video paths that should be preloaded
export const sectionVideoMap: Record<string, string[]> = {
  'overview': ['/videos/Contexto_objetivo_sistema.mp4', '/videos/Login_Navegacion.mp4'],
  'panel-requests': ['/videos/Solicitudes.mp4'],
  'validaciones-pendientes': ['/videos/Validaciones_pendientes.mp4'],
  'retiros-aprobados': ['/videos/Retiros_aprobados.mp4'],
  'completadas-rechazadas': ['/videos/Solicitudes_procesadas.mp4'],
  'wallet': ['/videos/Wallet.mp4'],
  'usuarios': ['/videos/Usuarios.mp4'],
  'operaciones': ['/videos/Operaciones.mp4']
};

// Function to find parent section
export const findParentSection = (key: string, data: any[]): string | null => {
  for (const item of data) {
    if (item.children) {
      for (const child of item.children) {
        if (child.key === key) {
          return item.key as string;
        }
      }
    }
  }
  return null;
};